import { IonToast } from '@ionic/react';
import type { ToastButton } from '@ionic/core';
import { useDispatch, useSelector } from 'react-redux';
import {
  removeToast,
  selectCurrentToast,
} from '../../store/slices/toast.slice';

const DEFAULT_TOAST_TIMEOUT = 3000;

/**
 * Displays toasts at a global level, can be triggered via the useToast hook
 */
export const ToastManager = () => {
  const currentToast = useSelector(selectCurrentToast);
  const dispatch = useDispatch();

  if (!currentToast) {
    return null;
  }

  const buttons: (string | ToastButton)[] = [];
  if (currentToast.action) {
    buttons.push({
      text: currentToast.action.label,
      handler: currentToast.action.handler,
    });
  }
  if (currentToast.isDismissible) {
    buttons.push('Close');
  }

  // Action toasts stay open until the user interacts so the link is clickable
  const persistent = currentToast.isDismissible || !!currentToast.action;

  return (
    <IonToast
      key={currentToast.id}
      isOpen={true}
      onDidDismiss={() => dispatch(removeToast())}
      message={currentToast.message}
      color={currentToast.variant}
      position={currentToast.position ?? 'bottom'}
      animated={true}
      buttons={buttons.length ? buttons : undefined}
      duration={
        persistent
          ? undefined // Persistent toasts stay until dismissed/interacted with
          : (currentToast.duration ?? DEFAULT_TOAST_TIMEOUT) // Otherwise it's configurable
      }
      className={'ch-toast'}
    />
  );
};
